const setEditMode = ({ commit }, payload) => {
  commit('setEditMode', payload)
}

export default {
  setEditMode,
}
